import Plugin from 'lib/modulor/plugin'

export default class PlaylistItem extends Plugin
  @defaults =
    debug: false
    name: 'AudioModule__PlaylistItem'
    is_loading_class_name: "audio_module__playlist__item__is_loading"
    is_paused_class_name: "audio_module__playlist__item__is_paused"
    is_playing_class_name: "audio_module__playlist__item__is_playing"

  @selector: ".audio_module__playlist__item"

  on_init: ->
    @$element.on "click.#{@options.name}", 'button', (e) =>
      if @is_playing()
        @$element.trigger('pause')
      else
        @$element.trigger('play')

    @$element.find("audio").first().on "canplay.#{@options.name} canplaythrough.#{@options.name}", (e) =>
      @$element.removeClass(@options.is_loading_class_name)

    @$element.on "play.#{@options.name}", (e) =>
      @play()

    @$element.on "pause.#{@options.name}", (e) =>
      @pause()

    @$element.on "reset.#{@options.name}", (e) =>
      @pause()
      @reset()

    @$element.find("audio").first().on "timeupdate.#{@options.name}", (e) =>
      @update_time_lapsed(e.currentTarget.currentTime)

  # ---------------------------------------------------------------------

  get_audio: -> @$element.find 'audio'
  get_time_lapsed: -> @$element.find(".audio_module__info__time_lapsed")

  # ---------------------------------------------------------------------

  is_playing: -> @$element.hasClass(@options.is_playing_class_name)

  # ---------------------------------------------------------------------

  play: () ->
    if @get_audio()[0].currentTime == 0
      @get_audio()[0].load()
      @$element.addClass(@options.is_loading_class_name)
    @get_audio()[0].play()
    @set_status('playing')

  pause: ->
    @get_audio()[0].pause()
    @set_status('paused')

  set_status: (status) ->
    switch status
      when 'paused'
        @$element.removeClass(@options.is_playing_class_name)
        @$element.addClass(@options.is_paused_class_name)
      when 'playing'
        @$element.addClass(@options.is_playing_class_name)
        @$element.removeClass(@options.is_paused_class_name)

  reset: (el) ->
    @get_audio()[0].currentTime = 0
    @get_time_lapsed().empty()

  update_time_lapsed: (currentTime) ->
    current_time_string = String(currentTime)
    sec_num = parseInt(current_time_string, 10)
    hours = Math.floor(sec_num / 3600)
    minutes = Math.floor((sec_num - (hours * 3600)) / 60)
    seconds = sec_num - (hours * 3600) - (minutes * 60)
    if hours < 10 then hours = '0' + hours
    if minutes < 10 then minutes = '0' + minutes
    if seconds < 10 then seconds = '0' + seconds
    @get_time_lapsed().html(hours + ':' + minutes + ':' + seconds)

PlaylistItem.register()
